module.exports = __webpack_public_path__ + "img/logo.e131748e.png";